import { Icon } from "../../Icon";
import { IIcon } from "../../interfaces/IIcon";

export const approvalNeutralIcon: IIcon = new Icon(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M32 5.333c14.704 0 26.667 11.963 26.667 26.667 0 14.704-11.963 26.667-26.667 26.667C17.296 58.667 5.333 46.704 5.333 32 5.333 17.296 17.296 5.333 32 5.333zM32 0C14.328 0 0 14.328 0 32s14.328 32 32 32 32-14.328 32-32S49.672 0 32 0zM16 29.333h32v5.334H16v-5.334z"/></svg>`
);
